import React, { useState } from 'react';
import { Modal, Button, ModalBody, ModalFooter } from 'reactstrap';
import { Document, Page } from 'react-pdf';
import { useIntl } from 'react-intl';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import IntlMessage from '../../../../../helpers/intlMessage';

const AnexoModal = ({ isOpen, onRequestClose, fileUrl, fileType, fileName }) => {
    const [numPages, setNumPages] = useState(null);
    const intl = useIntl();

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };

    return (
        <Modal
            isOpen={isOpen}
            toggle={onRequestClose}
            fileName={fileName}
            keyboard={true}
            size="lg"
        >
            <ModalHeader toggle={onRequestClose}>
                {fileName}
            </ModalHeader>
            {/* <ModalBody style={{ maxHeight: 'calc(80vh - 100px)', overflowY: 'auto', border: '1px solid #ccc', borderRadius: '5px'}}> */}
            <ModalBody style={{ maxHeight: 'calc(80vh - 100px)', overflowY: 'auto' }}>
                {fileType === 'pdf' && (
                    <Document
                        file={fileUrl}
                        onLoadSuccess={onDocumentLoadSuccess}
                        style={{ maxHeight: 'calc(80vh - 110px)', overflowY: 'auto' }}
                    >
                        {Array.from(new Array(numPages), (el, index) => (
                            <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                        ))}
                    </Document>
                )}

                {fileType === 'image' && (
                    <img
                        src={fileUrl}
                        alt="File"
                        style={{ maxWidth: '100%', maxHeight: 'calc(80vh - 110px)' }}
                    />
                )}

                {fileType === 'file' && (
                    <div>
                        <div>
                            <i className='mv-basico-pdf'></i>
                        </div>
                        <div className='anexo-nome'>
                            <a>{fileName}</a>
                        </div>
                    </div>
                )}
            </ModalBody>
            <ModalFooter>
                <Button onClick={() => {
                    const link = document.createElement('a');
                    link.style.display = 'none';
                    link.href = fileUrl;
                    link.download = fileName;
                    document.body.appendChild(link);
                    link.click();

                }} color="primary">
                    Download
                </Button>
                <Button onClick={onRequestClose} color="secondary">
                    <IntlMessage id="dashboards.examDetails.cancel" />
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default AnexoModal;



// WEBPACK FOOTER //
// ./src/app/common/tabs/anexo/modal/anexo.modal.js